import styled from "styled-components/macro";

export default styled.div`
  .provider-network-link {
    color: #000;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  .pnds-lookup-note {
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    strong {
      color: #000;
      font-weight: 700;
      line-height: 30px;
    }
  }
`;
